import * as React from "react";
import { Form, Input, Checkbox, InputNumber, DatePicker, Divider } from "antd";
import {
  ApplicantRequestsForm,
  InputNumberConstants,
  DateFormats
} from "../../../../common/Constants";
import TextArea from "antd/lib/input/TextArea";
import moment from "moment";
import Text from "antd/lib/typography/Text";
import SelectInput from "../../../components/app/SelectInput";

const ApplicantRequestForm = ({
  getFieldDecorator,
  translate,
  codebooks,
  rowData
}: {
  getFieldDecorator: any;
  translate: any;
  rowData?: any;
  codebooks?: any;
}) => {
  const reportingPeriods = codebooks[0];
  const requestTypes = codebooks[1];
  var expandedReportingPeriod;
  codebooks.length === 3
    ? (expandedReportingPeriod = codebooks[2])
    : (expandedReportingPeriod = undefined);
  return (
    <Form>
      <Form.Item
        label={translate("applicantRequests_form.reportingPeriod")}
        style={{ maxWidth: "100%" }}
      >
        {getFieldDecorator(
          ApplicantRequestsForm.Fields.REPORTING_PERIOD_APPLICANT_ID,
          {
            initialValue: expandedReportingPeriod?.id.toString(),
            rules: [
              {
                required: true,
                message: translate("applicantRequests_form.required_messages", {
                  field: translate("applicantRequests_form.reportingPeriod")
                })
              }
            ]
          }
        )(
          <SelectInput
            disabled={rowData}
            placeholder={translate(
              "applicantRequests_form.selectReportingPeriod"
            )}
            showSearch={true}
            notFoundContent={translate("search.no_data")}
            selectOptionKey={"id"}
            selectOptionValue={"reportingPeriodName"}
            selectOptions={reportingPeriods}
          />
        )}
      </Form.Item>
      <Form.Item label={translate("applicantRequests_form.name")}>
        {getFieldDecorator(ApplicantRequestsForm.Fields.NAME, {
          initialValue: rowData && rowData.name,
          rules: [
            {
              required: rowData ? false : true,
              message: translate("applicantRequests_form.required_messages", {
                field: translate("applicantRequests_form.name")
              })
            }
          ]
        })(
          <Input
            maxLength={ApplicantRequestsForm.VALIDATION_RULES.NAME_MAX_LENGTH}
          />
        )}
      </Form.Item>
      <div className="ant-form-row-two-items">
        <Form.Item
          label={translate("applicantRequests_form.requestType")}
          style={{ width: "100%", marginRight: 20 }}
        >
          {getFieldDecorator(ApplicantRequestsForm.Fields.REQUEST_TYPE_CODE, {
            initialValue: rowData && rowData.requestTypeCode,
            rules: [
              {
                required: true,
                message: translate("applicantRequests_form.required_messages", {
                  field: translate("applicantRequests_form.requestType")
                })
              }
            ]
          })(
            <SelectInput
              placeholder={translate(
                "applicantRequests_form.selectRequestType"
              )}
              showSearch={true}
              notFoundContent={translate("search.no_data")}
              selectOptionKey={"code"}
              selectOptionValue={"name"}
              selectOptions={requestTypes}
            />
          )}
        </Form.Item>
        <Form.Item label={translate("applicantRequests_form.priority")}>
          {getFieldDecorator(ApplicantRequestsForm.Fields.PRIORITY, {
            initialValue: rowData && rowData.priority,
            rules: [
              {
                required: true,
                message: translate("applicantRequests_form.required_messages", {
                  field: translate("applicantRequests_form.priority")
                })
              }
            ]
          })(<InputNumber min={InputNumberConstants.MIN_VALUE} />)}
        </Form.Item>
      </div>

      <Divider></Divider>

      <div className="ant-form-row-container">
        <Text style={{ fontWeight: "bold" }}>
          {translate("applicantRequests_form.valid_description")}
        </Text>
        <div className="ant-form-row-two-items">
          <Form.Item
            label={translate("applicantRequests_form.validFrom")}
            style={{ width: "100%", marginRight: 20 }}
          >
            {getFieldDecorator(ApplicantRequestsForm.Fields.VALID_FROM, {
              initialValue:
                rowData &&
                rowData.validFrom &&
                moment(rowData.validFrom, DateFormats.DATE),
              rules: [
                {
                  required: true,
                  message: translate(
                    "applicantRequests_form.required_messages",
                    {
                      field: translate("applicantRequests_form.validFrom")
                    }
                  )
                }
              ]
            })(
              <DatePicker
                placeholder={translate("applicantRequests_form.select_date")}
                locale={{ dateFormat: DateFormats.DATE }}
                showToday={false}
                style={{ width: "100%" }}
              />
            )}
          </Form.Item>
          <Form.Item
            label={translate("applicantRequests_form.validTo")}
            style={{ width: "100%" }}
          >
            {getFieldDecorator(ApplicantRequestsForm.Fields.VALID_TO, {
              initialValue:
                rowData && rowData.validTo
                  ? moment(rowData.validTo, DateFormats.DATE)
                  : undefined
            })(
              <DatePicker
                placeholder={translate("applicantRequests_form.select_date")}
                locale={{ dateFormat: DateFormats.DATE }}
                showToday={false}
                style={{ width: "100%" }}
              />
            )}
          </Form.Item>
        </div>
      </div>

      <Divider></Divider>

      <Form.Item label={translate("applicantRequests_form.content")}>
        {getFieldDecorator(ApplicantRequestsForm.Fields.CONTENT, {
          initialValue: rowData && rowData.content,
          rules: [
            {
              required: false,
              message: translate("role_type_form.required_messages", {
                field: translate("applicantRequests_form.content")
              })
            }
          ]
        })(<TextArea autoSize={{ minRows: 3 }} />)}
      </Form.Item>
      <Form.Item label={translate("applicantRequests_form.valid")}>
        {getFieldDecorator(ApplicantRequestsForm.Fields.VALID, {
          valuePropName: "checked",
          initialValue: rowData ? rowData.valid : true,
          rules: [
            {
              required: true
            }
          ]
        })(<Checkbox />)}
      </Form.Item>
    </Form>
  );
};

export default ApplicantRequestForm;
